import { gql } from '@efficiently/client-core-graphql-models';

export const CANCEL_PLAN_DETECTION = gql(`
	mutation CancelPlanDetection($planItemId: String!, $runId: String!) {
		cancelPlanDetection(planItemId: $planItemId, runId: $runId)
	}
`);
